import { Component, Input } from '@angular/core';
import { PopoverController, ModalController } from 'ionic-angular';
import * as ComparisonActions from '../../actions/comparison.actions';

import * as companies from '../../actions/companies.actions';
// ngrx/store
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers'
@Component({
  selector: 'sidebar-comparison',
  templateUrl: 'sidebar-comparison.html'
})
export class SidebarComparisonComponent {

  @Input() sidebar: string;
  @Input() comparison: any;
  
  charts: any = [{
    id: 'ebitMargin',
    name: 'Ebit Margin'
  },{
    id: 'fai',
    name: 'Fixed Asset Intensity'
  },{
    id: 'wci',
    name: 'Working Capital Intensity'
  },{
    id: 'iroce',
    name: 'IROCE'
  },{
    id: 'indexedEbitEstimate',
    name: 'Indexed Ebit Estimates'
  }
];

  constructor(public popoverCtrl: PopoverController, public modalCtrl: ModalController,
    private store: Store<fromRoot.State>) {
    
  }

  showCompaniesPopover($event, choice) {
    let companiesPopover = this.modalCtrl.create('CompaniesPage');
    companiesPopover.onDidDismiss(res => {
      if (res){
        this.store.dispatch(new ComparisonActions.FetchCompanyForComparison({ticker: res.ticker, choice}));
      }
    });
    companiesPopover.present({
      ev: $event
    });
  }

  removeCompany(choice: number) {
    this.store.dispatch(new ComparisonActions.RemoveCompanyFromComparison(choice));
  }
  reorderCompanies($event) {
    this.store.dispatch(new ComparisonActions.ReorderCompanyComparison($event));
  }

  updateChart(chartId) {
    this.store.dispatch(new ComparisonActions.SetChart(chartId));
  }
}



// WEBPACK FOOTER //
// ./src/components/sidebar-comparison/sidebar-comparison.ts